export const ADD_ITEM_TO_CART = 'ADD_ITEM_TO_CART';
export const REMOVE_ITEM_TO_CART = 'REMOVE_ITEM_TO_CART';
export const PROCEED_TO_CHECK_OUT = 'PROCEED_TO_CHECK_OUT';
export const PROCEED_TO_CHECK_OUT_SUCCESS = 'PROCEED_TO_CHECK_OUT_SUCCESS';
